@if(showPreviewDialog){
<p-splitter #splitter class="w-full h-full" [panelSizes]="[70, 30]" [minSizes]="minPanelSizes"
    (onResizeEnd)="onResizePanel($event)" [ngClass]="{'single-panel': !showPreviewDialog}">
    <ng-template pTemplate>
        <ng-container *ngTemplateOutlet="leftPanelTemplate"></ng-container>
    </ng-template>
    <ng-template pTemplate>
        <div class="preview-panel flex flex-col h-full w-full" [ngClass]="{'show': showPreviewDialog}">
            @if(selectedAttachment) {
            <div class="flex justify-between items-center pl-3 border-b">
                <h3 class="text-lg font-semibold">{{selectedAttachment.name}}</h3>
                <app-button variant="outlined" icon="pi pi-times" (clicked)="closePreview()" />
            </div>
            @if(selectedAttachment._id && selectedAttachment.attachment) {
            <app-document-preview class="h-full w-full" [documentId]="selectedAttachment._id"
                [file]="selectedAttachment.attachment">
            </app-document-preview>
            }
            }
        </div>
    </ng-template>
</p-splitter>
}
@else {
<ng-container *ngTemplateOutlet="leftPanelTemplate"></ng-container>
}

<!-- Add/Edit Attachment Dialog -->
<app-dialog [(visible)]="showAttachmentDialog" [title]="isEditMode ? 'Edit Attachment' : 'Add Attachment'"
    (closed)="closeAttachmentDialog()" class="max-w-[600px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-3 p-4">
            <!-- Name Field -->
            <div class="flex flex-col gap-2">
                <label for="attachmentName" class="text-sm font-semibold text-gray-600">Name</label>
                <input id="attachmentName" pInputText type="text" class="p-2 w-full border rounded-base"
                    placeholder="Type here" [(ngModel)]="attachmentForm.name" />
            </div>

            <!-- Description Field -->
            <div class="flex flex-col gap-2">
                <label for="attachmentDescription" class="text-sm font-semibold text-gray-600">Description <span
                        class="text-gray-500">(Optional)</span></label>
                <textarea id="attachmentDescription" pInputTextarea class="w-full border rounded-base"
                    placeholder="Type here" rows="4" [(ngModel)]="attachmentForm.description"></textarea>
            </div>

            <div>
                @if(attachmentForm.attachment) {
                <div class="flex flex-row gap-2 attachment-preview w-full items-center">
                    <div class="flex flex-row gap-2 items-center w-full">
                        @if(attachmentForm.attachment.type === 'application/pdf') {
                        <i class="pi pi-file-pdf text-2xl text-danger"></i>
                        } @else if (attachmentForm.attachment.type ===
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                        attachmentForm.attachment.type === 'application/msword') {
                        <i class="pi pi-file-word text-2xl text-blue-500"></i>
                        } @else {
                        <i class="pi pi-file text-2xl text-gray-400"></i>
                        }
                        <div class="flex flex-col justify-between w-full gap-1">
                            <span class="text-xs truncate">{{attachmentForm.attachment.filename}}</span>
                            @if(attachmentForm.attachment.updatedAt) {
                            <span class="text-xs">Updated on: {{attachmentForm.attachment.updatedAt |
                                dateFormatter:'MM/DD/YYYY'}}</span>
                            }
                        </div>
                    </div>
                    <i class="pi pi-trash text-danger cursor-pointer transition-opacity duration-200"
                        (click)="attachmentForm.attachment = null"></i>
                </div>
                } @else {
                <app-file-drop #fileDrop [fileTypes]="allowedFileTypes" (uploadData)="onFileUpload($event)"
                    (removeFile)="onFileRemove($event)" [maxFileSize]="50 * 1000 * 1000" [multiple]="false"
                    [existingFiles]="formFile ? [formFile] : []" />
                }
            </div>

            <!-- Expiry Date Field -->
            <div class="flex flex-col gap-2">
                <label for="attachmentExpiryDate" class="text-sm font-semibold text-gray-600">Expiry Date</label>
                <app-datepicker [(value)]="attachmentForm.expiryDate" [config]="{
                    showIcon: true,
                    showButtonBar: false,
                    iconDisplay: 'input',
                    appendTo: 'body',
                    readonly: true,
                    minDate: today,
                    autofocus: false,
                }" class="w-full" />
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-3">
            <app-button label="Cancel" variant="outlined" icon="pi pi-times" (clicked)="closeAttachmentDialog()" />
            <app-button label="Save" icon="pi pi-save" variant="filled" [loading]="saveAttachmentLoading"
                (clicked)="saveAttachment()" severity="primary" />
        </div>
    </ng-template>
</app-dialog>

@if(deleteAttachmentDialogVisible){
<app-delete-confirmation [(visible)]="deleteAttachmentDialogVisible" headerText="Are you sure?"
    bodyText="This action will delete the Attachment permanently!" confirmButtonText="Proceed"
    (onConfirm)="confirmDeleteAttachment()">
</app-delete-confirmation>
}

<ng-template #leftPanelTemplate>
    <div class="flex flex-col gap-3 flex-1 p-2 sm:p-3 h-full w-full min-h-0">
        <!-- Top Actions Bar - Responsive -->
        <div class="flex flex-wrap gap-2 sm:gap-3 w-full">
            <app-button label="Add" variant="filled" severity="primary" icon="pi pi-plus" (clicked)="addAttachment()" />
            <div class="w-full sm:w-auto sm:flex-1 sm:max-w-xs md:max-w-sm lg:max-w-md xl:w-[25%]">
                <app-search-bar placeholder="Search..." [(ngModel)]="searchValue"
                    (ngModelChange)="onSearch($event)"></app-search-bar>
            </div>
        </div>
        <!-- Content Area with Grid and Paginator -->
        <div class="flex flex-col gap-3 flex-1 min-h-0 overflow-hidden">
            <div class="flex-1 min-h-0 max-h-full overflow-hidden">
                <app-grid-list-view [items]="paginatedAttachments" [viewMode]="'grid'" [useDataTable]="false"
                    [gridItemTemplate]="gridItemTemplate" [dataKey]="'_id'" [scrollable]="true" [rows]="rows"
                    [rowsPerPageOptions]="[20, 40, 60]" [totalRecords]="totalRecords" [first]="first"
                    [showPaginator]="true" (pageChange)="onPageChange($event)" [maxHeight]="'100%'"
                    [parentClass]="'flex-1 min-h-0 max-h-full'" [itemsLoading]="attachmentsLoading" [gridGap]="3">
                </app-grid-list-view>

                <!-- Grid Item Template -->
                <ng-template #gridItemTemplate let-attachment>
                    <div
                        class="flex flex-col justify-between gap-2 sm:gap-3 border rounded-base p-3 sm:p-4 bg-white shadow group w-full h-full">
                        <!-- Card Header - Responsive -->
                        <div class="flex justify-between items-center gap-2 flex-nowrap">
                            <div class="flex gap-1 sm:gap-2 items-center flex-1 min-w-0 flex-nowrap">
                                <span class="font-bold text-sm sm:text-md truncate" pTooltip="{{ attachment.name }}"
                                    tooltipPosition="bottom">{{ attachment.name
                                    }}</span>
                                <app-status-badge
                                    [status]="attachment.expiryExtractionStatus ?? attachment.documentKnowledge?.embeddingsStatus"></app-status-badge>
                            </div>
                            <div class="flex gap-1 sm:gap-2 items-center flex-shrink-0">
                                @if(getExpiryInfo(attachment.expiryDate)) {
                                <app-badge
                                    [status]="getExpiryInfo(attachment.expiryDate)?.status === 'expired' ? 'Expired' : 'Expiring'"
                                    [text]="true"
                                    [badgeType]="getExpiryInfo(attachment.expiryDate)?.status === 'expired' ? 'danger' : 'pending'"
                                    [pTooltip]="getExpiryInfo(attachment.expiryDate)?.tooltip" tooltipPosition="bottom">
                                </app-badge>
                                }
                                <app-popover #menuPopover [width]="'auto'">
                                    <ng-template #trigger>
                                        <i class="pi pi-ellipsis-v icon-xs cursor-pointer"></i>
                                    </ng-template>
                                    <ng-template #body>
                                        @for (item of getMenuItems(attachment); track item.label) {
                                        <div class="flex items-center gap-3 p-2 cursor-pointer hover:bg-gray-100"
                                            [ngClass]="item['class']"
                                            (click)="handleMenuItemClick(attachment, item, menuPopover)">
                                            <i [ngClass]="item.icon"></i>
                                            <span>{{ item.label }}</span>
                                        </div>
                                        }
                                    </ng-template>
                                </app-popover>
                            </div>
                        </div>

                        <!-- Attachment File Section - Responsive -->
                        @if(attachment.attachment) {
                        <div class="flex flex-col gap-2 attachment-preview w-full cursor-pointer"
                            (click)="viewAttachment(attachment)">
                            <div class="flex flex-row gap-2 items-center justify-between">
                                @if(attachment.attachment.type === 'application/pdf') {
                                <i class="pi pi-file-pdf text-xl sm:text-2xl text-danger flex-shrink-0"></i>
                                } @else if (attachment.attachment.type ===
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                                attachment.attachment.type === 'application/msword') {
                                <i class="pi pi-file-word text-xl sm:text-2xl text-blue-500 flex-shrink-0"></i>
                                } @else {
                                <i class="pi pi-file text-xl sm:text-2xl text-gray-400 flex-shrink-0"></i>
                                }
                                <div class="flex flex-col justify-between flex-1 min-w-0 gap-1">
                                    <span class="text-xs truncate" pTooltip="{{ attachment.attachment.filename }}"
                                        tooltipPosition="bottom">{{ attachment.attachment.filename }}</span>
                                    <span class="text-xs truncate" pTooltip="Updated on: {{attachment.attachment.updatedAt |
                                        dateFormatter:'MM/DD/YYYY'}}">Updated on: {{attachment.attachment.updatedAt |
                                        dateFormatter:'MM/DD/YYYY'}}</span>
                                </div>
                                <i class="pi pi-trash text-danger text-sm cursor-pointer opacity-0 sm:group-hover:opacity-100 transition-opacity duration-200 flex-shrink-0"
                                    (click)="$event.stopPropagation(); removeAttachment(attachment._id)"></i>
                            </div>
                        </div>
                        } @else {
                        <div class="cursor-pointer">
                            <app-file-drop [fileTypes]="allowedFileTypes" [multiple]="false" [minimalView]="true"
                                (uploadData)="onFormUpload($event, attachment._id)" [maxFileSize]="90 * 1000 * 1000" />
                        </div>
                        }

                        <!-- Card Metadata Section - Responsive -->
                        <div class="py-2 flex-1 border-t text-xs text-gray-600">
                            @if(attachment.description) {
                            <div class="w-full mb-2">
                                <span class="line-clamp-2 sm:truncate block" pTooltip="{{ attachment.description }}">
                                    {{ attachment.description }}
                                </span>
                            </div>
                            }
                            @if(attachment.updatedBy) {
                            <div class="mt-1 flex justify-between items-center gap-2">
                                <span class="flex-shrink-0">Updated By:</span>
                                <app-user-name-display [user]="attachment.updatedBy"></app-user-name-display>
                            </div>
                            }
                            @if(attachment.expiryDate) {
                            <div class="flex justify-between items-center mt-1 gap-2">
                                <span class="flex-shrink-0">Expiry Date:</span>
                                <span class="font-bold truncate "
                                    pTooltip="{{ attachment.expiryDate | dateFormatter:'MM/DD/YYYY' }}">{{
                                    attachment.expiryDate |
                                    dateFormatter:'MM/DD/YYYY'
                                    }}</span>
                            </div>
                            }
                            <div class="flex justify-between items-center mt-1 gap-2">
                                <span class="flex-shrink-0">Last Edit:</span>
                                <span class="font-bold  truncate"
                                    pTooltip="{{ attachment.updatedAt | dateFormatter:'MM/DD/YYYY' }}">{{
                                    attachment.updatedAt |
                                    dateFormatter:'MM/DD/YYYY'
                                    }}</span>
                            </div>
                        </div>

                        @if(attachment.expiryExtractionStatus === EMBEDDINGS_GENERATION_STATUS.FAILED && isExpiryCreditsExhausted(attachment._id)) {
                        <app-credits-overview variant="exhaustioncard" feature="EXPIRY_DATE_EXTRACTION"
                            [featureId]="attachment._id" (resume)="onResumeExpiryExtraction()" />
                        }
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</ng-template>
